import React from 'react';
import SelectField from '../../Forms/Input/SelectField';
import DatePicker from '../../Forms/DatePicker/DatePicker';

interface Branch {
  id: number;
  name: string;
}

interface Customer {
  id: number;
  name: string;
}

interface DocumentType {
  id: number;
  name: string;
}

interface SaleSummary {
  branch: Branch;
  customer: Customer;
  documentType: DocumentType;
  saleDate: string; // formato YYYY-MM-DD
}

interface Props {
  sale: SaleSummary;
}

const SaleHeaderView: React.FC<Props> = ({ sale }) => {
  return (
    <div className="w-full rounded-sm border border-stroke bg-white p-6 shadow-default dark:border-strokedark dark:bg-boxdark">
      {/* Sucursal y Cliente */}
      <div className="mb-6 grid gap-4 sm:grid-cols-2">
        <SelectField
          label="Sucursal"
          name="branch"
          iconKey="building" // Usa un icono apropiado
          value={sale.branch?.id}
          options={[{ value: sale.branch?.id, label: sale.branch?.name }]}
          onChange={() => {}}
          disabled
        />

        <SelectField
          label="Cliente"
          name="customer"
          iconKey="user"
          value={sale.customer?.id}
          options={[{ value: sale.customer?.id, label: sale.customer?.name }]}
          onChange={() => {}}
          disabled
        />
      </div>

      {/* Tipo de Documento y Fecha */}
      <div className="mb-6 grid gap-4 sm:grid-cols-2">
        <SelectField
          label="Tipo de Documento"
          name="documentType"
          iconKey="list"
          value={sale.documentType?.id}
          options={[
            { value: sale.documentType?.id, label: sale.documentType?.name },
          ]}
          onChange={() => {}}
          disabled
        />

        <DatePicker
          label="Fecha"
          name="saleDate"
          iconKey="calendar"
          value={sale.saleDate}
          onChange={() => {}}
          disabled
        />
      </div>
    </div>
  );
};

export default SaleHeaderView;
